import { DEFAULT_WORKSPACE_SNAPPING } from "@utils/constant";
import BaseHandler from "./BaseHandler";
import CoreHandler from "./CoreHandler";
import { AligningGuidelines } from "@lib/fabric/guidelines";

const BASE_MARGIN = 10;

class SnappingHandler extends BaseHandler {
  public coreHandler: CoreHandler;

  public snapping: AligningGuidelines | undefined;

  public isEnabled: boolean = false;

  private handleZoomChanged = () => {
    if (this.snapping && this.coreHandler.canvas) {
      this.snapping.margin = BASE_MARGIN;
      this.coreHandler.canvas.requestRenderAll();
    }
  };

  constructor(coreHandler: CoreHandler) {
    super();
    this.coreHandler = coreHandler;
  }

  initialize(): void {
    const { canvas } = this.coreHandler;

    this.snapping = new AligningGuidelines(canvas, {
      margin: BASE_MARGIN,
    });

    // Listen for zoom changes
    this.coreHandler.workspaceHandler.on(
      "zoom:changed",
      this.handleZoomChanged
    );

    if (DEFAULT_WORKSPACE_SNAPPING) {
      this.enable();
    }
  }

  enable(): void {
    this.snapping?.enable();
    this.isEnabled = true;
    this.emit("snapping:changed", this.isEnabled);
  }

  disable(): void {
    this.snapping?.disable();
    this.isEnabled = false;
    this.emit("snapping:changed", this.isEnabled);
  }

  destroy(): void {
    this.coreHandler.workspaceHandler.off(
      "zoom:changed",
      this.handleZoomChanged
    );
    this.disable();
  }
}

export default SnappingHandler;
